import { render, staticRenderFns } from "./RFQDetails.vue?vue&type=template&id=812a7676&scoped=true"
import script from "./RFQDetails.vue?vue&type=script&lang=js"
export * from "./RFQDetails.vue?vue&type=script&lang=js"
import style0 from "./RFQDetails.vue?vue&type=style&index=0&id=812a7676&prod&scoped=true&lang=css"
import style1 from "./RFQDetails.vue?vue&type=style&index=1&id=812a7676&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "812a7676",
  null
  
)

export default component.exports